<template>
  <div id="app">

    <div class="sticky-nav px-4">

    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Products</h1>
    </div>

    <div class="dropdown">
      <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Actions
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" v-on:click="modalNewProduct()"><i class="fas fa-pencil-alt"></i> New</a>
        <a v-if="productsSelected.length == 1" class="dropdown-item" v-on:click="modalEditProduct()"><i class="fas fa-pencil-alt"></i> Edit</a>
        <a v-if="productsSelected.length > 1" class="dropdown-item" v-on:click="modalEditProducts()"><i class="fas fa-pencil-alt"></i> Edit</a>
        <a class="dropdown-item" v-on:click="modalGroupProducts()"><i class="fas fa-layer-group"></i> Group products</a>
        <a class="dropdown-item" v-on:click="delProducts()" href="#"><i class="fas fa-trash"></i> Delete</a>
      </div>
    </div>
    <div class="dropdown">
      <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Table views
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" v-on:click="basicView()"><i class="fas fa-table"></i> Basic</a>
        <a class="dropdown-item" v-on:click="attributesView()"><i class="fas fa-table"></i> Attributes</a>
      </div>
    </div>

    <button type="button" class="btn btn-dark" v-on:click="autoGroup()"> Auto-grouping</button>
    <button type="button" class="btn btn-primary" v-on:click="modalImport()"> Import</button>

    </div>

    <br /><br />

    <vue-good-table v-if="products"
          mode="remote"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          :totalRows="totalRecords"
          :isLoading.sync="isLoading"
          class="mb-3 px-4"
          @on-selected-rows-change="selectionChanged"
          @on-cell-click="onRowClick"
          :columns="productColumns"
          :rows="products"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            perPage: 25,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
            dropdownAllowAll: true,
          }"
          :selectOptions="{
            enabled: true,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
          }"
    />

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add grouped product</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="tab-content" id="nav-tabContent2">
              <div class="tab-pane fade show active pt-3" id="nav-new" role="tabpanel" aria-labelledby="nav-new-tab">
                <input type="text" class="form-control" v-model="addNewGroupedProduct.an" placeholder="Article N°" />
                <input type="text" class="form-control" v-model="addNewGroupedProduct.name" placeholder="Name" />
                <input type="text" class="form-control" v-model="addNewGroupedProduct.color" placeholder="Color" />
                <input type="text" class="form-control" v-model="addNewGroupedProduct.trade" placeholder="Trade" />
                <input type="text" class="form-control" v-model="addNewGroupedProduct.retail" placeholder="Retail" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="saveGroupedProduct()">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="editProductModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Product</a>
                <a class="nav-item nav-link" id="nav-category-tab" data-toggle="tab" href="#nav-category" role="tab" aria-controls="nav-category" aria-selected="false">Category</a>
                <a class="nav-item nav-link" id="nav-attributes-tab" data-toggle="tab" href="#nav-attributes" role="tab" aria-controls="nav-attributes" aria-selected="false">Attributes</a>
                <a class="nav-item nav-link" id="nav-woocommerce-tab" data-toggle="tab" href="#nav-woocommerce" role="tab" aria-controls="nav-woocommerce" aria-selected="false">WooCommerce</a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active pt-3" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <div v-if="productsSelected.length < 2">
                <label>Grouped ID</label><input type="text" class="form-control" v-model="editProduct.var_prod_id"/>
                <label>AN</label><input type="text" class="form-control" v-model="editProduct.an" placeholder="AN" />
                <label>EAN</label><input type="text" class="form-control" v-model="editProduct.ean" placeholder="EAN" />
                <label>Name</label><input type="text" class="form-control" v-model="editProduct.name" placeholder="Name" />
                </div>
                <label>Trade</label><input type="text" class="form-control" v-model="editProduct.trade" placeholder="Trade" />
                <label>Retail</label><input type="text" class="form-control" v-model="editProduct.retail" placeholder="Retail" />
                <label>Tax (%)</label><input type="text" class="form-control" v-model="editProduct.tax" placeholder="Tax" />
                <label>Description (NL)</label><textarea type="text" class="form-control" v-model="editProduct.desc_nl" placeholder="Description (NL)" />
                <label>Description (FR)</label><textarea type="text" class="form-control" v-model="editProduct.desc_fr" placeholder="Description (FR)" />
                <label>Description (EN)</label><textarea type="text" class="form-control" v-model="editProduct.desc_en" placeholder="Description (EN)" />
                <label>Stock</label><input type="text" class="form-control" v-model="editProduct.stock" placeholder="Stock" />
                <label>Min. stock</label><input type="text" class="form-control" v-model="editProduct.minstock" placeholder="Min. stock" />
                <label>EOL</label>
                  <select class="form-control" v-model="editProduct.eol">
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                  </select>
              </div>
              <div class="tab-pane fade pt-3" id="nav-category" role="tabpanel" aria-labelledby="nav-category-tab">
                <label>Category</label>
                <select class="form-control cat-select" v-model="editProduct.cid" :required="true">
                  <option
                   v-for="category in editProduct.categories"
                   v-bind:key="category.id"
                   v-bind:value="category.id"
                   :selected="category.id == editProduct.cid"
                  >{{ category.name }}</option>
                </select>
              </div>
              <div class="tab-pane fade pt-3" id="nav-attributes" role="tabpanel" aria-labelledby="nav-attributes-tab">
                <div v-if="editProduct.attributes.length > 0">
                  <div v-for="(product) in editProduct.attributes" v-bind:key="product.id">
                    <label>{{ product.aname }}</label>
                    <input type="text" class="form-control" v-model="product.value" />
                  </div>
                </div>
              </div>
              <div class="tab-pane fade pt-3" id="nav-woocommerce" role="tabpanel" aria-labelledby="nav-woocommerce-tab">
                <label>ID</label>
                <input type="text" class="form-control" v-model="editProduct.woo_id" placeholder="ID" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="sProduct(editProduct.id)">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="newProductModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-new-tab" data-toggle="tab" href="#nav-new-home" role="tab" aria-controls="nav-new-home" aria-selected="true">Product</a>
                <a class="nav-item nav-link" id="nav-category-new-tab" data-toggle="tab" href="#nav-new-category" role="tab" aria-controls="nav-new-category" aria-selected="false">Category</a>
                <a class="nav-item nav-link" id="nav-attributes-new-tab" data-toggle="tab" href="#nav-new-attributes" role="tab" aria-controls="nav-new-attributes" aria-selected="false">Attributes</a>
              </div>
            </nav>
            <div class="tab-content" id="nav-new-tabContent">
              <div class="tab-pane fade show active pt-3" id="nav-new-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <label>AN</label><input type="text" class="form-control" v-model="newProduct.an" placeholder="AN" />
                <label>EAN</label><input type="text" class="form-control" v-model="newProduct.ean" placeholder="EAN" />
                <label>Name</label><input type="text" class="form-control" v-model="newProduct.name" placeholder="Name" />
                <label>Trade</label><input type="text" class="form-control" v-model="newProduct.trade" placeholder="Trade" />
                <label>Retail</label><input type="text" class="form-control" v-model="newProduct.retail" placeholder="Retail" />
                <label>Tax (%)</label><input type="text" class="form-control" v-model="newProduct.tax" placeholder="Tax" />
                <label>Description (NL)</label><textarea type="text" class="form-control" v-model="newProduct.desc_nl" placeholder="Description (NL)" />
                <label>Description (FR)</label><textarea type="text" class="form-control" v-model="newProduct.desc_fr" placeholder="Description (FR)" />
                <label>Description (EN)</label><textarea type="text" class="form-control" v-model="newProduct.desc_en" placeholder="Description (EN)" />
                <label>Stock</label><input type="text" class="form-control" v-model="newProduct.stock" placeholder="Stock" />
                <label>Min. stock</label><input type="text" class="form-control" v-model="newProduct.minstock" placeholder="Min. stock" />
                <label>EOL</label>
                  <select class="form-control" v-model="newProduct.eol">
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                  </select>
              </div>
              <div class="tab-pane fade pt-3" id="nav-new-category" role="tabpanel" aria-labelledby="nav-category-tab">
                <label>Category</label>
                <select class="form-control cat-select" v-model="newProduct.cid" :required="true" @change="newProductAttr">
                  <option
                   v-for="category in newProduct.categories"
                   v-bind:key="category.id"
                   v-bind:value="category.id"
                   :selected="category.id == newProduct.cid"
                  >{{ category.name }}</option>
                </select>
              </div>
              <div class="tab-pane fade pt-3" id="nav-new-attributes" role="tabpanel" aria-labelledby="nav-attributes-tab">
                <div v-if="newProduct.attributes.length > 0">
                  <div v-for="(product) in newProduct.attributes" v-bind:key="product.id">
                    <label>{{ product.aname }}</label>
                    <input type="text" class="form-control" v-model="product.value" />
                  </div>
                </div>
              </div>
              <div class="tab-pane fade pt-3" id="nav-related" role="tabpanel" aria-labelledby="nav-related-tab">
              </div>
              <div class="tab-pane fade pt-3" id="nav-images" role="tabpanel" aria-labelledby="nav-images-tab">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="sNewProduct()">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="editProductsModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-products-tab" data-toggle="tab" href="#nav-home-products" role="tab" aria-controls="nav-home" aria-selected="true">Product</a>
                <a class="nav-item nav-link" id="nav-category-products-tab" data-toggle="tab" href="#nav-category-products" role="tab" aria-controls="nav-category" aria-selected="false">Category</a>
                <a class="nav-item nav-link" id="nav-attributes-products-tab" data-toggle="tab" href="#nav-attributes-products" role="tab" aria-controls="nav-attributes" aria-selected="false">Attributes</a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active pt-3" id="nav-home-products" role="tabpanel" aria-labelledby="nav-home-products-tab">
                <div v-if="productsSelected.length < 2">
                <label>Name</label><input type="text" class="form-control" v-model="editProducts.name" placeholder="Name" />
                </div>
                <label>Trade</label><input type="text" class="form-control" v-model="editProducts.trade" placeholder="Trade" />
                <label>Retail</label><input type="text" class="form-control" v-model="editProducts.retail" placeholder="Retail" />
                <label>Tax (%)</label><input type="text" class="form-control" v-model="editProducts.tax" placeholder="Tax" />
                <label>Description (NL)</label><textarea type="text" class="form-control" v-model="editProducts.desc_nl" placeholder="Description (NL)" />
                <label>Description (FR)</label><textarea type="text" class="form-control" v-model="editProducts.desc_fr" placeholder="Description (FR)" />
                <label>Description (EN)</label><textarea type="text" class="form-control" v-model="editProducts.desc_en" placeholder="Description (EN)" />
                <label>Stock</label><input type="text" class="form-control" v-model="editProducts.stock" placeholder="Stock" />
                <label>Min. stock</label><input type="text" class="form-control" v-model="editProducts.minstock" placeholder="Min. stock" />
                <label>EOL</label>
                  <select class="form-control" v-model="editProducts.eol">
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                  </select>
              </div>
              <div class="tab-pane fade pt-3" id="nav-category-products" role="tabpanel" aria-labelledby="nav-category-products-tab">
                <label>Category</label>
                <select class="form-control cat-select" v-model="editProducts.cid" :required="true">
                  <option
                   v-for="category in editProducts.categories"
                   v-bind:key="category.id"
                   v-bind:value="category.id"
                   :selected="category.id == editProducts.cid"
                  >{{ category.name }}</option>
                </select>
              </div>
              <div class="tab-pane fade pt-3" id="nav-attributes-products" role="tabpanel" aria-labelledby="nav-attributes-products-tab">
                <div v-if="editProducts.attributes.length > 0">
                  <div v-for="(product) in editProducts.attributes" v-bind:key="product.id">
                    <label>{{ product.aname }}</label>
                    <input type="text" class="form-control" v-model="product.value" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="sProducts()">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="importModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Import products (.csv)</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning" role="alert">
              - Gebruik "|" als afscheidingsteken in het .csv bestand<br>
              - De eerste kolom moet steeds het artikelnr. bevatten
            </div>
            <div class="input-group mb-1 fullw">
              <div class="custom-file fullw">
                <input type="file" ref="file" class="custom-file-input" v-on:change="handleFileUpload()" id="inputGroupFile02">
                <label class="custom-file-label" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">Choose file</label>
              </div>
              <select class="fullw mt-2 custom-select" v-model="importCategory" :required="true">
                <option :value="-1" disabled="true">- Select category -</option>
                <option :value="0">Alle categorieën</option>
                <option
                 v-for="category in categories"
                 v-bind:key="category.id"
                 v-bind:value="category.id"
                >{{ category.name }}</option>
              </select>
              <select class="fullw mt-2 custom-select" v-model="importType" :required="true">
                <option :value="-1" disabled="true">- Select import type -</option>
                <option value="new">New</option>
                <option value="update">Update</option>
                <option value="combo">New + Update</option>
              </select>
            </div>
            <div class="input-group p-1">
              {{ importFeedback }}
            </div>
            <div class="input-group p-1">
              <form id="frmImport">
              <div v-for="(key) in csvKeys" v-bind:key="key" class="match-wrapper">
                <input disabled="disabled" class="form-control" type="text" :value="key"/>
                <select :name="key" class="custom-select">
                  <option :value="-1">- Select column -</option>
                  <option v-for="(sql, id) in sqlKeys" :value="id" v-bind:key="sql" :selected="sql == key">{{ sql }}</option>
                </select>
              </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="closeImport()">Close</button>
            <button type="button" class="btn" :class="readyForImport ? 'btn-secondary' : 'btn-primary'" v-on:click="uploadCSV">Upload</button>
            <button type="button" class="btn" :class="readyForImport ? 'btn-primary' : 'btn-secondary'" v-on:click="importCSV" :disabled="readyForImport ? false : true">{{ importStatus }}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="autoGroupModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Auto-group products <span>{{autoGroupStatus}}</span></h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <table>
              <tr v-for="group in autoGroupListItem" v-bind:key="group.id">
                <td><input type="checkbox" class="form-check-input" :value="group.an" v-model="autoGroupListItemsSelected"/></td>
                <td>{{ group.an }}</td>
                <td>{{ group.name }}</td>
              </tr>
            </table>
            <div class="pt-3">
              <input type="text" class="form-control" v-model="autoGroupProps.an" placeholder="Article N°" />
              <input type="text" class="form-control" v-model="autoGroupProps.name" placeholder="Name" />
              <input type="text" class="form-control" v-model="autoGroupProps.trade" placeholder="Trade" />
              <input type="text" class="form-control" v-model="autoGroupProps.retail" placeholder="Retail" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="closeAutoGroup()">Close</button>
            <button type="button" class="btn btn-dark" v-on:click="skipAutoGroup()">Skip</button>
            <button type="button" class="btn btn-primary" v-on:click="saveAutoGroup()">OK</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';

export default {
  name: 'app',
  components: {

  },
  data() {
    return{
      /*REMOTE*/
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: {
          field: '',
          type: '',
        },
        page: 1,
        perPage: 25
      },
      /* END REMOTE */
      importType : '-1',
      importCategory: '-1',
      categories: [],
      editModalTitle: '',
      groupedproducts: null,
      groupedproduct: null,
      groupedproductid: 1,
      products: null,
      test: null,
      inputgroupedproductid: null,
      productsSelected: [],
      groupedProductSelected: null,
      updateGroupedProduct: {
          value: '',
          text: ''
      },
      addNewGroupedProduct: {
        name:'',
        an: '',
        color: ''
      },
      selectAll: false,
      file: '',
      editGroupedProduct: {
        id: '',
        name: '',
        use: '',
        collection: '',
        price: '',
        manufacturer: ''
      },
      editProduct: {
        attributes: [],
        related: []
      },
      newProduct: {
        attributes: [],
        related: []
      },
      editProducts: {
        attributes: [],
        related: []
      },
      importFeedback: '',
      csvKeys: '',
      editType: '',
      sqlKeys: '',
      readyForImport: false,
      importStatus: 'Import',
      groupPos: -1,
      autoGroupStatus: '',
      autoGroupList: [],
      autoGroupListItem: [],
      autoGroupListItemsSelected: [],
      gpOptions: {},
      autoGroupProps: {
        trade: '',
        retail: '',
        manufacturer: '',
        color: '',
        size: '',
        name: '',
        an: ''
      },
      productColumns: [
        {label: 'G', field: 'grouped', html: true},
        {label: 'AN', field: 'an', filterOptions: {enabled: true}},
        {label: 'EAN', field: 'ean', filterOptions: {enabled: true}},
        {label: 'Name', field: 'name', filterOptions: {enabled: true}},
        {label: 'Trade', field: 'trade', filterOptions: {enabled: true}},
        {label: 'Retail', field: 'retail', filterOptions: {enabled: true}},
        {label: 'Category', field: 'cname', filterOptions: {enabled: true}}
      ],
      attrPos: 0
    }
  },
  mounted (){
    this.loadItems();
  },
  methods: {
    /* REMOTE */
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage});
      this.loadItems();
    },

    onSortChange(params) {

      this.updateParams({
        sort: params[0],
      });

      console.log(this.serverParams);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      console.log(this.serverParams);
      this.loadItems();
    },

    // load items is what brings back the rows from server
    loadItems() {

        axios
          .post('https://wrc.weblion.be/api/remote-products/',
          {
            serverParams: this.serverParams
          })
          .then(response => {
            this.totalRecords = response.data.totalRecords;
            this.products = response.data.rows;
            console.log(response.data);
          })

    },
    /* END REMOTE */
    delProducts(){
      var products = this.productsSelected;
      axios
        .post('https://wrc.weblion.be/api/delete-products.php/',
          {
            products: products,
          })
        .then((response) => {
          console.log(response.data);
          this.loadItems();
        })
    },
    closeImport(){
      this.importType = '-1';
      this.importCategory = '-1';
      this.csvKeys = '';
      this.sqlKeys = '';
      this.importFeedback = '';
      $("#importModal").modal('hide');
    },
    closeAutoGroup(){
      $("#autoGroupModal").modal('hide');
      this.groupPos = '-1';
    },
    skipAutoGroup(){
      this.nextGroup();
    },
    saveAutoGroup(){

      axios
        .post('https://wrc.weblion.be/api/save_auto_group.php',{
          props: this.autoGroupProps,
          products : this.autoGroupListItemsSelected
        })
        .then((res)=>{
          console.log(res);
          this.nextGroup();
        })
    },
    nextGroup(){

      function allEqual(arr) {
        return new Set(arr).size == 1;
      }

      if((this.groupPos + 1) < this.autoGroupList.length){

        this.groupPos += 1;
        this.autoGroupListItem = this.autoGroupList[this.groupPos];
        this.autoGroupStatus = (this.groupPos + 1) + ' of ' + this.autoGroupList.length;

        var retail = []; var trade = []; var color = []; var manufacturer = [];

        this.autoGroupListItem.forEach(function(item){
          retail.push(item['retail']);
          trade.push(item['trade']);
          color.push(item['color']);
          manufacturer.push(item['manufacturer']);
        });

        if(allEqual(retail)){
          this.autoGroupProps.retail = this.autoGroupListItem[0].retail;
        }else{
          this.autoGroupProps.retail = null;
        }

        if(allEqual(trade)){
          this.autoGroupProps.trade = this.autoGroupListItem[0].trade;
        }else{
          this.autoGroupProps.trade = null;
        }

        if(allEqual(color)){
          this.autoGroupProps.color = this.autoGroupListItem[0].color;
        }else{
          this.autoGroupProps.color = null;
        }

        if(allEqual(manufacturer)){
          this.autoGroupProps.manufacturer = this.autoGroupListItem[0].manufacturer;
        }else{
          this.autoGroupProps.manufacturer = null;
        }


        var i; var j;
        var name = '';
        var an = '';
        var arr2 = [];

        for(i = 0; i < this.autoGroupListItem[0].name.length; i++){
          arr2 = [];

          for(j = 0; j < this.autoGroupListItem.length; j++){
            arr2.push(this.autoGroupListItem[j].name.charAt(i));
          }

          if(arr2.every( (val, i, arr) => val === arr[0] )){
            name += arr2[0];
          }
        }

        for(i = 0; i < this.autoGroupListItem[0].an.length; i++){
          arr2 = [];

          for(j = 0; j < this.autoGroupListItem.length; j++){
            arr2.push(this.autoGroupListItem[j].an.charAt(i));
          }

          if(arr2.every( (val, i, arr) => val === arr[0] )){
            an += arr2[0];
          }else{
            an += 'x';
          }
        }

        this.autoGroupProps.name = name.trim();
        this.autoGroupProps.an = an;

        this.autoGroupListItemsSelected = [];

        this.autoGroupListItem.forEach(item => {
          this.autoGroupListItemsSelected.push(item['an']);
        });

      }else{
        this.closeAutoGroup();
      }

    },
    autoGroup(){
      axios
        .get('https://wrc.weblion.be/api/auto_group_products.php')
        .then((res)=>{
          this.autoGroupList = res.data;
          this.autoGroupListItem = this.autoGroupList[this.groupPos];
          this.autoGroupStatus = (this.groupPos + 1) + ' of ' + this.autoGroupList.length;
          this.nextGroup();
          $("#autoGroupModal").modal('show');
          console.log(this.autoGroupProps);
          console.log(this.autoGroupListItemsSelected);
        })
    },
    basicView(){
      this.productColumns = [
        {label: 'G', field: this.groupedStatusFn, html: true},
        {label: 'AN', field: 'an', filterOptions: {enabled: true}},
        {label: 'EAN', field: 'ean', filterOptions: {enabled: true}},
        {label: 'Name', field: 'name', filterOptions: {enabled: true}},
        {label: 'Trade', field: 'trade', filterOptions: {enabled: true}},
        {label: 'Retail', field: 'retail', filterOptions: {enabled: true}},
        {label: 'Category', field: 'cname', filterOptions: {enabled: true}}
      ];
    },
    attributesView(){

      this.productColumns = [
        {label: 'G', field: this.groupedStatusFn, html: true},
        {label: 'AN', field: 'an', filterOptions: {enabled: true}},
        {label: 'Name', field: 'name', filterOptions: {enabled: true}},
      ]

      var keys = Object.keys(this.products[0]);

      var products = this.products;

      keys.forEach((item) => {
        if(item.includes('a_')){

          var obj = {label: products[0][item].aname, field: item + '.value', filterOptions: {enabled: true}}
          this.productColumns.push(obj);
        }
      });

    },
    groupedStatusFn(rowObj){
      return "<span class='groupedState' data-g='" + rowObj.grouped + "'><span>";
    },
    saveGroupedProduct(){

      axios
        .post('https://wrc.weblion.be/api/save_grouped_product.php', {
            products: this.productsSelected,
            new: this.addNewGroupedProduct
        })
        .then(
          axios
          .get('https://wrc.weblion.be/api/products/')
          .then(response => {
            this.products = response.data;
            $("#exampleModal").modal('hide');
            this.loadItems();
          })
        )

    },
    getProducts(){
      //Object.freeze(this.products);
      axios
        .get('https://wrc.weblion.be/api/products/')
        .then(response => {
          this.products = response.data;
        })
    },
    handleFileUpload(){
      this.file = this.$refs.file.files[0];
      console.log(this.file.type);
      if(this.file.type != 'text/csv' && this.file.type != 'application/vnd.ms-excel' ){
        this.importFeedback = "Error: please upload a .csv file"
      }else{
        this.importFeedback = "Success: " + this.file.name + " is ready for upload";
      }
    },
    uploadCSV(){

      if(this.importType != '-1' && this.importCategory != '-1' && this.file != ''){
        let formData = new FormData();
        formData.append('file', this.file);

        axios.post('https://wrc.weblion.be/api/sql.php',{
          'cid' : this.importCategory
        })
        .then( (response) => {

          console.log(response.data);

          this.sqlKeys = response.data;

          console.log(this.sqlKeys);

          return axios.post('https://wrc.weblion.be/api/csv.php',formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            })

        })
        .then( (response) => {
          this.importFeedback = "Please match .csv columns to database.";
          this.csvKeys = response.data;
          this.readyForImport = true;
        })
      }

    },
    importCSV(){

      this.importStatus = 'Importing...'

      let formData = new FormData();
      let match = JSON.stringify($("#frmImport").serializeArray());
      let sql = JSON.stringify(this.sqlKeys);
      let csv = JSON.stringify(this.csvKeys);

      formData.append('file', this.file);
      formData.append('sql', sql);
      formData.append('match', match );
      formData.append('csv', csv);
      formData.append('category', this.importCategory);
      formData.append('type', this.importType);

      axios
        .post('https://wrc.weblion.be/api/import_csv.php', formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        )
      .then(response => {
        console.log(response);
        this.importStatus = 'Import';
        this.closeImport();
        this.loadItems();
      })
    },
    onRowClick(table){
      console.log(table.row);
      this.editModalTitle = 'Edit product';
      this.editProduct = table.row;
      var id = table.row.id;
      axios
        .post('https://wrc.weblion.be/api/attributes.php',
          {
            id: id
          })
        .then((response) => {
          this.$set(this.editProduct, 'attributes', response.data);
        })
        .then(() => {
          axios
          .get('https://wrc.weblion.be/api/categories.php')
          .then((response) => {
            this.$set(this.editProduct, 'categories', response.data);
          })
          .then(() => {
            $("#editProductModal").modal('show');
          })
        })
    },
    selectionChanged(table){
      this.productsSelected = table.selectedRows;
    },
    modalEditProducts(){

      this.editModalTitle = 'Edit products';

      var check = [];

      for(var i = 0; i < this.productsSelected.length; i++) {
          var p = this.productsSelected[i];
          for ( var key in p ) {
              if(key == 'cid'){
                check.push(p[key]);
              }
          }
      }

      var cat;

      if(check.every( (val, i, arr) => val === arr[0])){
        cat = this.productsSelected[0]['cid'];
        this.editProducts.cid = cat;
      }else{
        cat = 0;
      }

      axios
        .post('https://wrc.weblion.be/api/attributes.php',
          {
            cat: cat
          })
        .then((response) => {
          this.$set(this.editProducts, 'attributes', response.data);
        })
        .then(() => {
          axios
          .get('https://wrc.weblion.be/api/categories.php')
          .then((response) => {
            this.$set(this.editProducts, 'categories', response.data);
          })
          .then(() => {
            $("#editProductsModal").modal('show');
          })
        })

    },
    modalEditProduct(){

      this.editProduct = this.productsSelected[0];
      this.editModalTitle = 'Edit product';

        var id = this.editProduct.id;

        axios
          .post('https://wrc.weblion.be/api/attributes.php',
            {
              id: id
            })
          .then((response) => {
            this.$set(this.editProduct, 'attributes', response.data);
          })
          .then(() => {
            axios
            .get('https://wrc.weblion.be/api/categories.php')
            .then((response) => {
              this.$set(this.editProduct, 'categories', response.data);
            })
            .then(() => {
              $("#editProductModal").modal('show');
            })
          })

    },
    newProductAttr(){

      axios
        .post('https://wrc.weblion.be/api/attributes.php',
          {
            cat: this.newProduct.cid
          })
        .then((response) => {
          console.log(response.data);
          this.$set(this.newProduct, 'attributes', response.data);
        })

    },
    modalNewProduct(){

      this.editModalTitle = 'Add new product';

            axios
            .get('https://wrc.weblion.be/api/categories.php')
            .then((response) => {
              this.$set(this.newProduct, 'categories', response.data);
            })
            .then(() => {
              $("#newProductModal").modal('show');
            })

    },
    modalImport(){
      axios
      .get('https://wrc.weblion.be/api/categories.php')
      .then((response) => {
        this.categories = response.data;
        $("#importModal").modal('show');
      })
    },
    modalGroupProducts(){

      function allEqual(arr) {
        return new Set(arr).size == 1;
      }

      var retail = []; var trade = []; var color = []; var name = [];

      this.productsSelected.forEach(function(item){
        retail.push(item['retail']);
        trade.push(item['trade']);
        color.push(item['color']);
        name.push(item['name']);
      });

      if(allEqual(retail)){
        this.addNewGroupedProduct.retail = this.productsSelected[0].retail;
      }else{
        this.addNewGroupedProduct.retail = null;
      }

      if(allEqual(name)){
        this.addNewGroupedProduct.name = this.productsSelected[0].name;
      }else{
        this.addNewGroupedProduct.name = null;
      }

      if(allEqual(trade)){
        this.addNewGroupedProduct.trade = this.productsSelected[0].trade;
      }else{
        this.addNewGroupedProduct.trade = null;
      }

      if(allEqual(color)){
        this.addNewGroupedProduct.color = this.productsSelected[0].color;
      }else{
        this.addNewGroupedProduct.color = null;
      }

      var i; var j;
      var g_name = '';
      var g_an = '';
      var arr2 = [];

      for(i = 0; i < this.productsSelected[0].name.length; i++){
        arr2 = [];

        for(j = 0; j < this.productsSelected.length; j++){
          arr2.push(this.productsSelected[j].name.charAt(i));
        }

        if(arr2.every( (val, i, arr) => val === arr[0] )){
          g_name += arr2[0];
        }
      }

      for(i = 0; i < this.productsSelected[0].an.length; i++){
        arr2 = [];

        for(j = 0; j < this.productsSelected.length; j++){
          arr2.push(this.productsSelected[j].an.charAt(i));
        }

        if(arr2.every( (val, i, arr) => val === arr[0] )){
          g_an += arr2[0];
        }else{
          g_an += 'x';
        }
      }

      this.addNewGroupedProduct.name = g_name.trim();
      this.addNewGroupedProduct.an = g_an;

      axios
        .get('https://wrc.weblion.be/api/grouped-products/')
        .then((response) => {
          this.groupedproducts = response.data;
          $("#exampleModal").modal('show');
        })
    },
    sProduct(){
      axios
        .post('https://wrc.weblion.be/api/products/update.php',{
          product : this.editProduct
        })
        .then(response => ( console.log(response) ))
        .then(this.loadItems())
        .then(function(){ $("#editProductModal").modal('hide'); })
    },
    sNewProduct(){
      axios
        .post('https://wrc.weblion.be/api/new-product.php',{
          product : this.newProduct
        })
        .then(response => ( console.log(response) ))
        .then(this.loadItems())
        .then(function(){ $("#newProductModal").modal('hide'); })
    },
    sProducts(){

      var ids = [];

      for(var i = 0; i < this.productsSelected.length; i++) {
          var p = this.productsSelected[i];
          for ( var key in p ) {
              if(key == 'id'){
                ids.push(p[key]);
              }
          }
      }

      this.editProducts.id = ids.join();

      axios
        .post('https://wrc.weblion.be/api/products/update.php',{
          product : this.editProducts,
        })
        .then(response => ( console.log(response) ))
        .then(this.loadItems())
        .then(function(){ $("#editProductsModal").modal('hide'); })

    }


  }
}
</script>

<style>
button{
  margin-right: 10px;
}
.table thead th{
  text-align: left !important;
}
.pager ul{
  list-style-type: none;
}
.pager ul li{
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input{
  margin-bottom: 5px;
}
.modal-body label{
  display: inline-block;
  width: 32%;
}

.modal-body .form-control{
  display: inline-block;
  width: 68%;
}

.modal-body select{
  text-indent: 5px;
}

#exampleModal input{
  display: block;
  width: 100%;
}

#importModal .modal-body label{
  width: auto;
}

#importModal input, #importModal select{
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper, #importModal form{
  width: 100%;
}
#importModal select{
  margin-left: 1%;
}

#importModal .fullw{
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select{
  margin: 0;
}

#importModal .fullw input{
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown{
  display: inline-block;
}
.dropdown-item:hover{
  cursor: pointer !important;
}
.dropdown-item i{
  margin-right:3px;
}
@media (min-width: 576px){
  .modal-dialog {
      max-width: 550px;
      margin: 1.75rem auto;
  }
}
.groupedState{
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td{
  padding: 2px 10px;
}

#autoGroupModal .modal-title span{
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input{
  width: 100%;
}

#autoGroupModal .form-check-input{
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
    display: inline-block !important;
    width: 68% !important;
    margin-bottom: 5px !important;
}

.sticky-nav{
  position: fixed;
    height: 150px;
    top: 50;
    z-index: 2;
    background: white;
    padding-top: 10px;
        width: 100%;
        margin-top: -10px;
}

#editProductModal textarea{
  height: 100px;
}

.vgt-wrap{
  margin-top: 120px;
}

label{
  vertical-align: top;
}

[data-g='1']{
  background: #8CC040;
}

[data-g='0']{
  background: red;
}
</style>
